import { Navigate, useParams } from 'react-router-dom';

import useEnv from '@zenbusiness/application-commons-env';
import isValidUuid from '@zenbusiness/application-commons-utils/isValidUuid';

export default function ValidateEntityUuid({ children }) {
  const { businessEntityUuid } = useParams();

  const { PARENT_SEGMENT } = useEnv();

  if (businessEntityUuid && !isValidUuid(businessEntityUuid)) {
    return <Navigate to={PARENT_SEGMENT} />;
  }

  return children;
}
